<div ngbDropdown #notificationDropdown="ngbDropdown" [autoClose]="'outside'" class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
  <button ngbDropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle notification-btn shadow-sm" id="page-header-notifications-dropdown">
    <i class="bi bi-bell fs-2xl"></i>
    <span class="position-absolute topbar-badge fs-3xs translate-middle badge rounded-pill bg-danger pulse-animation">
      <span class="notification-badge">{{ totalNotify }}</span>
    </span>
  </button>

  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 shadow-lg notification-dropdown">
    <div class="dropdown-head bg-light-subtle p-3 border-bottom">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <h6 class="mb-1 fs-lg fw-semibold">
            <i class="bi bi-bell me-2 text-primary"></i> Notifications
            <span class="badge bg-danger-subtle text-danger fs-sm ms-2">{{ totalNotify }}</span>
          </h6>
          <p class="fs-md text-muted mb-0">
            You have
            <span class="fw-semibold text-primary">{{ newNotify }}</span> unread messages
          </p>
        </div>
        <div ngbDropdown>
          <a ngbDropdownToggle href="javascript:void(0);" class="btn btn-sm btn-icon btn-ghost-secondary rounded-circle">
            <i class="bi bi-three-dots-vertical"></i>
          </a>
          <ul ngbDropdownMenu class="dropdown-menu shadow-sm">
            <li>
              <a class="dropdown-item" href="javascript:void(0);" (click)="onMarkAllAsRead()"> <i class="bi bi-check-all me-2 text-success"></i>Mark all as read</a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0);" (click)="onDeleteAllNotifications()"> <i class="bi bi-trash me-2 text-danger"></i>All Clear</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="p-2" id="notificationItemsTabContent">
      <ngx-simplebar data-simplebar-track="light" style="max-height: 350px" class="px-2">
        @for (data of notificationList; track $index) {
          @for (item of data.items; track $index) {
            <div class="notification-item d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 p-3" [ngClass]="data.title == 'New' ? 'unread-message bg-light-subtle border-start border-bottom-0 border-4 border-primary' : 'border border-light-subtle'">
              <div class="d-flex align-items-start gap-3 flex-grow-1">
                <div *ngIf="item.avatar; else iconBlock" class="flex-shrink-0">
                  <img [src]="item.avatar" class="rounded-circle avatar-sm shadow-sm" alt="user-pic" />
                </div>
                <ng-template #iconBlock>
                  <div class="avatar-sm flex-shrink-0 shadow-sm">
                    <span class="avatar-title {{ item.background }} rounded-circle d-flex align-items-center justify-content-center">
                      <i class="{{ item.icon }}"></i>
                    </span>
                  </div>
                </ng-template>

                <div class="text-wrap flex-grow-1">
                  <h6 class="fs-md fw-semibold text-primary mb-1 notification-title-truncate" ngbTooltip="{{ item.name }}" placement="top">
                    {{ item.name }}
                  </h6>
                  <p class="fs-sm text-muted mb-0 notification-title-truncate">{{ item.text }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <span class="badge rounded-pill fs-xs px-2 py-1" [ngClass]="data.title == 'New' ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-secondary'"> <i class="bi bi-clock me-1 fs-xs"></i>{{ item.timestamp | timeAgo }} </span>
                <div class="form-check m-0">
                  <input class="form-check-input shadow-sm" type="checkbox" [(ngModel)]="item.state" (change)="onCheckboxChange($event, item.id)" id="{{ item.checkboxId }}" />
                </div>
                <button type="button" class="btn btn-sm btn-info rounded-pill px-3" (click)="openNotificationModal(item)" ngbTooltip="Voir les détails">View</button>
              </div>
            </div>
          }
        }
      </ngx-simplebar>

      <div class="notification-actions bg-light p-3 rounded-3 mt-2 shadow-sm" id="notification-actions">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center me-3 gap-2">
            <i class="bi bi-check-circle-fill text-success"></i>
            <span>
              Selected
              <span class="badge bg-primary rounded-pill mx-2">{{ checkedValGet.length }}</span>
              items
            </span>
          </div>

          <div class="d-flex align-items-center gap-3">
            <button type="button" class="btn btn-sm btn-danger" (click)="onNotificationDelete()"><i class="bi bi-trash me-1"></i>Remove</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeDropdown()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="empty-notification-elem text-center p-4" [class.d-none]="totalNotify > 0">
        <div class="avatar-md bg-light-subtle rounded-circle d-flex align-items-center justify-content-center mx-auto shadow-sm">
          <i class="bi bi-bell text-primary fs-2"></i>
        </div>
        <div class="py-4 mt-3">
          <h6 class="fs-lg fw-semibold lh-base">You're all caught up!</h6>
          <p class="text-muted">No new notifications to display</p>
        </div>
      </div>

      <div class="text-center p-2 border-top">
        <button type="button" class="btn btn-link link-primary fw-medium" (click)="toList()" *ngIf="checkedValGet.length === 0">View All <i class="bi bi-arrow-right ms-1"></i></button>
      </div>
    </div>
  </div>
</div>
